import { useQuery } from '@tanstack/react-query';
import { Pose, StudentImage } from '../models';
import useLocalStorage from "./useLocalStorage";

export default function useHolidayPoses(studentId) {
  const [currentSeason] = useLocalStorage(`currentSeason-${studentId}`);

  return useQuery(['student images', studentId], () => (
    StudentImage
      .includes({ poses: { addonSheets: 'addon' } })
      .where({ studentId, folder:  currentSeason || 'fall2025' })
      .merge({ poses: Pose.where({ noJpgs: true }) })
      .first()
      .then((res) => {
        if (!res.data) return [];

        return res.data.poses;
      })
  ), { enabled: !!studentId, placeholderData: [] });
}
